// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__eCHmu","label":"NotFound_label__tez9T","description":"NotFound_description__9gZXX","title":"NotFound_title__1u90p"};